(function () {
  //console.log("[ecofort] review-widget scroll script loaded");
  var scrollOffset = 80;
  function scrollToReviewWidget() {
    var target = document.getElementById("detailed-review__widget");
    if (!target) {
      console.warn("[ecofort] #detailed-review__widget not found");
      return;
    }
    var tab1 = document.getElementById("tab-1");
    var needTabSwitch = tab1 && !tab1.classList.contains("current");
    if (needTabSwitch) {
      var tab1Link = document.querySelector('.product_submenu ul.tabs li[data-tab="tab-1"]');
      if (tab1Link) {
        document.querySelectorAll(".product_submenu ul.tabs li").forEach(function (li) { li.classList.remove("current"); });
        document.querySelectorAll(".product_submenu .tab-content").forEach(function (el) { el.classList.remove("current"); });
        tab1Link.classList.add("current");
        tab1.classList.add("current");
      }
    }
    function doScroll() {
      var y = target.getBoundingClientRect().top + window.pageYOffset - scrollOffset;
      window.scrollTo({ top: y, behavior: "smooth" });
    }
    var initialDelay = needTabSwitch ? 150 : 0;
    setTimeout(doScroll, initialDelay);
    setTimeout(function () {
      doScroll();
    }, initialDelay + 600);
  }
  function handleReviewWidgetClick(e) {
    var container = e.target && e.target.closest && e.target.closest(".star-reviews-container");
    var wrapper = e.target && e.target.closest && e.target.closest(".rating-wrapper");
    if (!wrapper || wrapper.classList.contains("no-scroll")) {
      return;
    }
    var hit = container || wrapper;
    if (!hit) return;
    e.preventDefault();
    e.stopPropagation();
    scrollToReviewWidget();
  }
  document.addEventListener("click", handleReviewWidgetClick, true);
  document.addEventListener("keydown", function (e) {
    if (e.key !== "Enter" && e.key !== " ") return;
    var container = e.target && e.target.closest && e.target.closest(".star-reviews-container");
    if (!container) return;
    e.preventDefault();
    scrollToReviewWidget();
  }, true);
})();

document.addEventListener('DOMContentLoaded', () => {
  compareAppHandler();
  initTrustLoginPlacement();
  initHideHcaptchaBadge();
});

function initHideHcaptchaBadge() {
  hideHcaptchaBadge();

  [100, 500, 1500, 3000].forEach(function (delay) {
    setTimeout(hideHcaptchaBadge, delay);
  });

  new MutationObserver(hideHcaptchaBadge).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
}

function hideHcaptchaBadge() {
  var selectors = [
    '#shop-hcaptcha-badge-container',
    '.hcaptcha-badge',
    '#hcaptcha-badge',
    '.grecaptcha-badge',
    '[data-hcaptcha-badge]',
  ];

  selectors.forEach(function (selector) {
    document.querySelectorAll(selector).forEach(function (el) {
      el.style.setProperty('display', 'none', 'important');
      el.style.setProperty('visibility', 'hidden', 'important');
      el.style.setProperty('opacity', '0', 'important');
    });
  });

  document.querySelectorAll('img[alt*="hCaptcha"], img[alt*="hcaptcha"]').forEach(function (img) {
    var container = img.closest('#shop-hcaptcha-badge-container, [id*="hcaptcha"], [class*="hcaptcha"]') || img.parentElement;
    if (!container || container === document.body) return;
    container.style.setProperty('display', 'none', 'important');
    container.style.setProperty('visibility', 'hidden', 'important');
    container.style.setProperty('opacity', '0', 'important');
  });
}

function initTrustLoginPlacement() {
  relocateTrustLogin();

  var retryDelays = [100, 300, 500, 1000, 2000, 4000, 8000, 12000];
  retryDelays.forEach(function (delay) {
    setTimeout(relocateTrustLogin, delay);
  });

  window.addEventListener('resize', relocateTrustLogin);

  var menuDrawer = document.getElementById('Details-menu-drawer-container');
  if (menuDrawer) {
    menuDrawer.addEventListener('toggle', relocateTrustLogin);
  }

  new MutationObserver(relocateTrustLogin).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
}

function relocateTrustLogin() {
  var drawerSlot = document.getElementById('menu-drawer-trustlogin-slot');
  var footerSlot = document.getElementById('footer-trustlogin-slot');
  var cartWrap = document.querySelector('.header__cart_wrap');
  var isMobile = window.matchMedia('(max-width: 989px)').matches;
  var targetSlot = isMobile ? drawerSlot : footerSlot || null;

  if (!drawerSlot && !footerSlot) return;

  function moveWidgetToSlot(widget, slot) {
    if (slot && widget && !slot.contains(widget)) {
      slot.appendChild(widget);
    }
  }

  function moveAppBlockToSlot(block, slot) {
    if (slot && block && block.querySelector('trstd-login') && !slot.contains(block)) {
      slot.appendChild(block);
    }
  }

  function dedupeWidgets(slot) {
    if (!slot) return;
    var widgets = slot.querySelectorAll('trstd-login');
    for (var i = 1; i < widgets.length; i += 1) {
      widgets[i].remove();
    }
  }

  if (isMobile && drawerSlot) {
    document.querySelectorAll('trstd-login').forEach(function (widget) {
      moveWidgetToSlot(widget, drawerSlot);
    });

    document.querySelectorAll('.header__icons .shopify-app-block, .shopify-app-block').forEach(function (block) {
      if (block.querySelector('trstd-login')) {
        moveAppBlockToSlot(block, drawerSlot);
      }
    });

    if (cartWrap && cartWrap.previousElementSibling) {
      var sibling = cartWrap.previousElementSibling;
      if (
        (sibling.matches('trstd-login') ||
          sibling.classList.contains('shopify-app-block') ||
          sibling.querySelector('trstd-login')) &&
        !drawerSlot.contains(sibling)
      ) {
        drawerSlot.appendChild(sibling);
      }
    }

    dedupeWidgets(drawerSlot);

    drawerSlot.querySelectorAll('trstd-login, .shopify-app-block').forEach(function (el) {
      el.style.display = '';
    });

    document.querySelectorAll('.header__icons > trstd-login').forEach(function (widget) {
      widget.style.display = drawerSlot.contains(widget) ? '' : 'none';
    });

    document.querySelectorAll('.header__icons .shopify-app-block').forEach(function (block) {
      if (block.querySelector('trstd-login')) {
        block.style.display = drawerSlot.contains(block) ? '' : 'none';
      }
    });
  } else if (footerSlot) {
    document.querySelectorAll('trstd-login').forEach(function (widget) {
      moveWidgetToSlot(widget, footerSlot);
    });

    document.querySelectorAll('.header__icons .shopify-app-block, .shopify-app-block').forEach(function (block) {
      if (block.querySelector('trstd-login')) {
        moveAppBlockToSlot(block, footerSlot);
      }
    });

    if (cartWrap && cartWrap.previousElementSibling) {
      var headerSibling = cartWrap.previousElementSibling;
      if (
        (headerSibling.matches('trstd-login') ||
          headerSibling.classList.contains('shopify-app-block') ||
          headerSibling.querySelector('trstd-login')) &&
        !footerSlot.contains(headerSibling)
      ) {
        footerSlot.appendChild(headerSibling);
      }
    }

    dedupeWidgets(footerSlot);

    footerSlot.querySelectorAll('trstd-login, .shopify-app-block').forEach(function (el) {
      el.style.display = '';
    });

    document.querySelectorAll('.header__icons > trstd-login, .header__icons .shopify-app-block').forEach(function (el) {
      if (el.querySelector('trstd-login') || el.matches('trstd-login')) {
        el.style.display = footerSlot.contains(el) ? '' : 'none';
      }
    });
  } else if (cartWrap) {
    if (drawerSlot) {
      drawerSlot.querySelectorAll('trstd-login').forEach(function (widget) {
        if (cartWrap.parentNode) {
          cartWrap.parentNode.insertBefore(widget, cartWrap);
        }
      });

      drawerSlot.querySelectorAll('.shopify-app-block').forEach(function (block) {
        if (block.querySelector('trstd-login') && cartWrap.parentNode) {
          cartWrap.parentNode.insertBefore(block, cartWrap);
          block.style.display = '';
        }
      });
    }

    document.querySelectorAll('.header__icons > trstd-login, .header__icons .shopify-app-block').forEach(function (el) {
      el.style.display = '';
    });
  }
}

$(document).ready(function () {
  if (
    navigator.userAgent.indexOf("Safari") !== -1 &&
    navigator.userAgent.indexOf("Chrome") === -1
  ) {
    $("body").addClass("safari-print");
  }

  $(
    "summary.header__menu-item, ul.header__submenu, ul.header__subsubmenu"
  ).hover(function () {
    $(this).parent("details").attr("open", "open");
  });
  $("summary.header__menu-item, ul.header__submenu").mouseleave(function () {
    $(this).parent("details").removeAttr("open");
  });

  $(document).on("click", "a", function (e) {
    if (!$(this).attr("href") || $(this).attr("href") === "#") {
      e.preventDefault();
    }
  });

  if ($("body").hasClass("template-product")) {
    setTimeout(function () {
      media_gallery_slider();
      setMaxHeight();
    }, 3000);
  } else {
    media_gallery_slider();
    setMaxHeight();
  }

  $(document).on("mouseenter", ".media_gallery_slider", function () {
    $(this).slick("play");
  });
  $(document).on("mouseleave", ".media_gallery_slider", function () {
    $(this).slick("slickGoTo", 0);
    $(this).slick("pause");
  });

  // menu code
  $(document).on(
    "click",
    ".menu-drawer__navigation .menu-drawer__menu-item",
    function (e) {
      $(".menu-drawer__navigation .menu-drawer__menu-item")
        .not($(this))
        .removeClass("active");
      $(this).toggleClass("active");
    }
  );

  $(document).on(
    "click",
    ".header-top-section li:has(.srv_sub_menu_wrap)",
    function (e) {
      $(this).toggleClass("active");
    }
  );
});
function setMaxHeight() {
  $(".product-grid").each(function () {
    var maxHeight = -1;
    $(this)
      .find(".usp_attribute_wrapper")
      .each(function () {
        maxHeight = maxHeight > $(this).height() ? maxHeight : $(this).height();
      });

    if (maxHeight > 0) {
      $(this)
        .find(".usp_attribute_wrapper")
        .each(function () {
          $(this).height(maxHeight);
        });
    }

    var maxHeadingHeight = -1;
    $(this)
      .find(".card__heading")
      .each(function () {
        maxHeadingHeight =
          maxHeadingHeight > $(this).height()
            ? maxHeadingHeight
            : $(this).height();
      });

    if (maxHeadingHeight > 0) {
      $(this)
        .find(".card__heading")
        .each(function () {
          $(this).height(maxHeadingHeight);
        });
    }
  });
}

function media_gallery_slider() {
  $(".media_gallery_slider").slick({
    arrows: false,
    dots: true,
    slideToScroll: 1,
    slideToShow: 1,
    autoplaySpeed: 1000,
    // autoplay: true,
  });
}

function formatDateString(date, format = "regular", time = "") {
  var days = ["SO", "MO", "DI", "MI", "DO", "FR", "SA"];

  var newDate = date.split(" ");
  var newTime = newDate[1].split(":");

  date = newDate[0] + "T" + newDate[1] + "Z";
  var d = new Date(date);

  var month = d.getUTCMonth() + 1;
  var day = d.getUTCDate();
  var dayname = days[d.getUTCDay()] + ", ";
  var year = d.getUTCFullYear();
  var hour = d.getUTCHours();
  var minute = d.getUTCMinutes();

  if (month.length < 2) {
    month = "0" + month;
  }

  var min = "",
    h = "",
    dt = "",
    mt = "",
    tm = "";

  if (day.length < 2) {
    day = "0" + day;
  }
  if (minute < 10) {
    min = 0;
  }
  if (hour < 10) {
    h = 0;
  }
  if (day < 10) {
    dt = 0;
  }
  if (month < 10) {
    mt = 0;
  }
  if (time == "false") {
    tm = "";
  } else {
    // tm = ', '+h+hour+':'+min+minute;
    tm = ", " + newTime[0] + ":" + newTime[1];
  }
  if (format == "without_day") {
    dayname = "";
  }
  return dayname + dt + day + "." + mt + month + "." + year + tm;
}

const formatDate = (date, syear = "true") => {
  const monthNames = [
    "Januar",
    "Februar",
    "März",
    "April",
    "Mai",
    "Juni",
    "Juli",
    "August",
    "September",
    "Oktober",
    "November",
    "Dezember",
  ];
  var newDate = date.split(" ");
  var newTime = newDate[1].split(":");

  date = newDate[0] + "T" + newDate[1] + "Z";
  var d = new Date(date);

  var month = monthNames[d.getUTCMonth()].toString();
  var day = d.getUTCDate().toString();
  var year = d.getUTCFullYear();
  var hour = d.getUTCHours();
  var minute = d.getUTCMinutes();
  if (month.length < 2) {
    month = "0" + month;
  }

  var min = "",
    h = "";
  if (day.length < 2) {
    day = "0" + day;
  }
  if (minute < 10) {
    min = 0;
  }
  if (hour < 10) {
    h = 0;
  }
  if (syear == "false") {
    year = newTime[0] + ":" + newTime[1];
  }

  return day + ". " + month + " " + year;
};

function youtube_parser(url) {
  var regExp =
    /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
  var match = url.match(regExp);
  return match && match[7].length == 11 ? match[7] : false;
}
function handlizer(str) {
  var handle = str
    .toLowerCase()
    .replace(/\s+/g, "-") // Replace spaces with -
    .replace(/[^\w\-]+/g, "") // Remove all non-word chars
    .replace(/\-\-+/g, "-") // Replace multiple - with single -
    .replace(/^-+/, "") // Trim - from start of text
    .replace(/-+$/, "");

  return handle;
}

// bottom to top scroll button js start
(function ($) {
  "use strict";

  $(document).ready(function () {
    "use strict";

    //Scroll back to top

    var progressPath = document.querySelector(
      ".bottom_to_top_progress_wrap path"
    );
    var pathLength = progressPath.getTotalLength();
    progressPath.style.transition = progressPath.style.WebkitTransition =
      "none";
    progressPath.style.strokeDasharray = pathLength + " " + pathLength;
    progressPath.style.strokeDashoffset = pathLength;
    progressPath.getBoundingClientRect();
    progressPath.style.transition = progressPath.style.WebkitTransition =
      "stroke-dashoffset 10ms linear";
    var updateProgress = function () {
      var scroll = $(window).scrollTop();
      var height = $(document).height() - $(window).height();
      var docheight = $(".footer").height();
      var progress = pathLength - (scroll * pathLength) / height;
      progressPath.style.strokeDashoffset = progress;
      if ($(".social").length > 0) {
        var footerOffset = $(".social").offset().top;
        if (scroll >= footerOffset) {
          $(".bottom_to_top_progress_wrap").addClass("reached-footer");
        } else {
          $(".bottom_to_top_progress_wrap").removeClass("reached-footer");
        }
      }
    };
    updateProgress();
    $(window).scroll(updateProgress);
    var offset = 50;
    var duration = 550;
    jQuery(window).on("scroll", function () {
      if (jQuery(this).scrollTop() > offset) {
        jQuery(".bottom_to_top_progress_wrap").addClass("active-progress");
        jQuery("#freshworks-container").addClass("active-progress");
        $("#trustbadge-container-98e3dadd90eb493088abdc5597a70810").addClass(
          "active-progress"
        );
      } else {
        jQuery(".bottom_to_top_progress_wrap").removeClass("active-progress");
        jQuery("#freshworks-container").removeClass("active-progress");
        $("#trustbadge-container-98e3dadd90eb493088abdc5597a70810").removeClass(
          "active-progress"
        );
      }
    });

    // jQuery('.bottom_to_top_progress_wrap').on('click', function(event) {
    //     event.preventDefault();
    //     if ($(this).hasClass('reached-footer')) {
    //         // If the element has the class 'reached-footer', scroll to the top
    //         jQuery('html, body').animate({scrollTop: 0}, 550);
    //     } else {
    //         // If not, scroll to the bottom of the page
    //         var scrollTo = $(document).height() - $(window).height();
    //         jQuery('html, body').animate({scrollTop: scrollTo}, 550);
    //     }
    //     return false;
    // });

    jQuery(".bottom_to_top_progress_wrap").on("click", function (event) {
      event.preventDefault();

      jQuery("html, body").animate({ scrollTop: 0 }, 550);

      return false;
    });
  });
})(jQuery);
// bottom to top scroll button js start

// $(document).on('click', 'a[href^="#"]', function (event) {
//     event.preventDefault();

//     if($.attr(this, 'href') != '#'){
//       $('html, body').animate({
//         scrollTop: $($.attr(this, 'href')).offset().top - 80
//       }, 500);
//     }
// });

// $(document).ready(function () {
//   const productInfoWrapper = $(
//     ".product.product--large:not(.product--no-media) .product__info-wrapper.fixed"
//   );
//   const footer = $(".footer-payment-wrap");

//   // Function to handle scrolling behavior
//   const handleScroll = () => {
//     const scrollTop = $(window).scrollTop();
//     const windowHeight = $(window).height();
//     const sectionTop = $(".footer").offset().top;

//     // Handle product info wrapper position based on footer visibility
//     if ($(window).width() > 992 && productInfoWrapper.length > 0 && footer.length > 0) {
//       const maxY = footer.offset().top - productInfoWrapper.outerHeight() - 130;
//       if (scrollTop + windowHeight > sectionTop) {
//         if (scrollTop < maxY) {
//           productInfoWrapper.removeClass("posAbs").removeAttr("style");
//         } else {
//           productInfoWrapper.addClass("posAbs").css({
//             "--top": `${Math.trunc(maxY)}px`,
//           });
//         }
//       } else {
//         productInfoWrapper.removeClass("posAbs");
//       }
//     }
//   };

//   // Function to handle smooth scrolling with offset
//   const smoothScroll = (target) => {
//     $("html, body").animate(
//       {
//         scrollTop: $(target).offset().top - 100,
//       },
//       300
//     );
//   };

//   // Event listener for scroll
//   $(window).on("scroll", handleScroll);

//   // Smooth scroll on anchor link click
//   $('a[href^="#"]').on("click", function (event) {
//     if ($(this).hasClass("not_prevent") || this.hash === undefined) return;
//     event.preventDefault();
//     const target = $(this).attr("href");
//     if (target !== "#") {
//       smoothScroll(target);
//     }
//   });

//   // Smooth scroll on page load if there’s a hash in the URL
//   function scrollToHash () {
//     const hash = window.location.hash;
//     if (hash) {
//       smoothScroll(hash);
//     }
//   }
//   scrollToHash ()
//   subscribe(PUB_SUB_EVENTS.fetchContentLoaded, (e) => {
//      scrollToHash();
//   });
// });


$(document).ready(function () {
  const productInfoWrapper = $('.product.product--large:not(.product--no-media) .product__info-wrapper');
  const footer = $('.footer');
  const triggerSection = $('.product__info-container'); // change if your first section has a different class

  if (!productInfoWrapper.length || !footer.length || !triggerSection.length) return;

  const updatePosition = () => {
    const scrollTop = $(window).scrollTop();
    const footerTop = footer.offset().top;
    const wrapperHeight = productInfoWrapper.outerHeight(true);
    const triggerBottom = triggerSection.offset().top + triggerSection.outerHeight();

    const stickyTopOffset = 105;
    const maxScrollForSticky = footerTop - wrapperHeight - stickyTopOffset - 90;

    if (scrollTop >= triggerBottom && scrollTop < maxScrollForSticky) {
      // STICKY STATE
      productInfoWrapper
        .removeClass('posAbs')
        .addClass('sticky')
        .css('top', `${stickyTopOffset}px`);
    } else if (scrollTop >= maxScrollForSticky) {
      // ABSOLUTE STOP ABOVE FOOTER
      productInfoWrapper
        .removeClass('sticky')
        .addClass('posAbs')
        .css('top', `${maxScrollForSticky}px`);
    } else {
      // RESET TO DEFAULT (BEFORE TRIGGER SECTION)
      productInfoWrapper
        .removeClass('sticky posAbs')
        .css('top', '');
    }
  };

  $(window).on('scroll resize', updatePosition);
  updatePosition();
});


$(document).ready(function () {
  // $(window).on("scroll", function () {
  //   // Get the scroll position of the window
  //   var scrollTop = $(this).scrollTop();

  //   // Get the position of the section
  //   var sectionTop = $(".footer").offset().top;
  //   const productInfoWrapper = $(
  //     ".product.product--large:not(.product--no-media) .product__info-wrapper.fixed"
  //   );
  //   // const top = productInfoWrapper.offset().top - 100 - parseFloat(productInfoWrapper.css('marginTop').replace(/auto/, 0));
  //   const maxY = sectionTop - productInfoWrapper.outerHeight();
  //   const y = $(this).scrollTop();
  //   // Check if the section is in the viewport
  //   if (scrollTop + $(window).height() > sectionTop) {
  //     // Remove the class when the section is in the viewport
  //     $(
  //       ".product.product--large:not(.product--no-media) .product__info-wrapper"
  //     ).addClass("posAbs");
  //     productInfoWrapper.addClass("posAbs").css({
  //       "--top": `${Math.trunc(maxY)}px`,
  //     });
  //   } else {
  //     productInfoWrapper.removeClass("posAbs");
  //   }
  // });

  /*sidecart on product page*/
  // $(window).on("scroll", function () {
  //   if ($(window).width() > 992) {
  //     const productInfoWrapper = $(
  //       ".product.product--large:not(.product--no-media) .product__info-wrapper.fixed"
  //     );

  //     if(productInfoWrapper.length > 0){
  //       const footer = $(".footer-payment-wrap");
  //       if (!footer) return false;
  //       var scrollTop = $(this).scrollTop();
  //       const top =
  //         productInfoWrapper.offset().top -
  //         70 -
  //         parseFloat(productInfoWrapper.css("marginTop").replace(/auto/, 0));
  //       const footTop =
  //         footer.offset().top -
  //         130 -
  //         parseFloat(footer.css("marginTop").replace(/auto/, 0));
  //       const maxY = footTop - productInfoWrapper.outerHeight();
  //       var sectionTop = $(".footer-payment-wrap").offset().top;
  //       const y = $(this).scrollTop();
  //       if (scrollTop + $(window).height() > sectionTop) {
  //         if (scrollTop < maxY) {
  //           productInfoWrapper.removeClass("posAbs").removeAttr("style");
  //         } else {
  //           productInfoWrapper.addClass("posAbs").css({
  //             "--top": `${Math.trunc(maxY)}px`,
  //           });
  //         }
  //       } else {
  //         productInfoWrapper.removeClass("posAbs");
  //       }
  //     }
  //   }
  // });

  /**/

  // Function to handle smooth scrolling with offset
  const smoothScroll = (target) => {
    $("html, body").animate(
      {
        scrollTop: $(target).offset().top - 80,
      },
      300
    );
  };

  // Smooth scroll on click
  $('a[href^="#"]').on("click", function (event) {
    const hash = window.location.hash;
    if ($(this).hasClass("not_prevent") || $(this).hash === undefined) {
      return 0;
    }
    if ($(this).hasClass("review__widget_link")) {
      event.preventDefault();
      return;
    }
    event.preventDefault();
    const target = $(this).attr("href");
    if (target != "#") {
      smoothScroll(target);
    }
  });

  $(document).on("click", function (event) {
    var $link = $(event.target).closest(".review__widget_link");
    if (!$link.length) return;
    event.preventDefault();
    event.stopPropagation();
    var context = $link.closest("#product-info").length ? "product-info" : $link.closest(".product-media-modal, [data-product-modal]").length ? "media-modal" : $link.closest(".promo-product, [data-promo]").length ? "promo-product" : "unknown";
    var $target = $("#detailed-review__widget");
    if (!$target.length) {
      console.warn("[review__widget_link] target #detailed-review__widget not found");
      return;
    }
    var $tab1 = $("#tab-1");
    var needTabSwitch = $tab1.length && !$tab1.hasClass("current");
    if (needTabSwitch) {
      $(".product_submenu ul.tabs li").removeClass("current");
      $(".product_submenu .tab-content").removeClass("current");
      $('.product_submenu ul.tabs li[data-tab="tab-1"]').addClass("current");
      $tab1.addClass("current");
    }
    setTimeout(function () {
      $("html, body").animate(
        { scrollTop: $target.offset().top - 80 },
        300
      );
    }, needTabSwitch ? 100 : 0);
  });

  // Check if there's a hash in the URL on page load
  const hash = window.location.hash;
  if (hash) {
    smoothScroll(hash);
  }
});

// $(function () {
//   if ($("body").hasClass("template-collection")) {
//     if (
//       $(".template-collection .subcategories-menu").length &&
//       $(".template-collection .collection-subcategories").length
//     ) {

//       let slickConfig = {
//         slidesToScroll: 2,
//         autoplay: false,
//         speed: 1000,
//         variableWidth: true,
//         infinite: false,
//         swipe: true,
//         arrows: true,
//         speed: 300,
//         swipeToSlide: true,

//       };

//       function setSliderSubCat() {
//         let containerWidth =
//           $(".template-collection .collection-subcategories").width() || 0;
//         let totalWidth = 0;
//         $(".template-collection .subcategory-item").each(function () {
//           totalWidth += $(this).outerWidth(true); // Include margins if necessary
//         });

//         if (totalWidth !== 0 && containerWidth !== 0) {
//           if (totalWidth >= containerWidth) {
//             $(
//               ".template-collection .subcategories-menu:not(.slick-initialized)"
//             ).slick(slickConfig);
//           } else {
//             $(
//               ".template-collection .subcategories-menu.slick-initialized"
//             ).slick("unslick");
//           }
//         }
//       }

//       setSliderSubCat();
//       $(window).resize(function () {
//         setSliderSubCat();
//       });
//     }
//   }

// });

$(document).ready(function () {
  var wishlistCount = $(".header__icons .uwl-count").text();

  if (wishlistCount == 0) {
    //console.log('wishlistCount 0', wishlistCount);
    $(".header__icons .wishlist-link").removeClass("wishlist-has-val");
  } else {
    $(".header__icons .wishlist-link").addClass("wishlist-has-val");
  }

  $(document).on(
    "click",
    ".uwl-col-wishlist, .uwl-remove-wishlist",
    function () {
      var wishlistCount = $(".header__icons .uwl-count").text();
      if (wishlistCount == 0) {
        $(".header__icons .wishlist-link").removeClass("wishlist-has-val");
      } else {
        $(".header__icons .wishlist-link").addClass("wishlist-has-val");
      }
      if (wishlistCount == 1 && $(this).hasClass("uwl-remove-wishlist")) {
        setTimeout(function () {
          location.reload();
        }, 300);
      }
    }
  );

  // Set interval
  if ($(".uwl-wishlist-container").length > 0) {
    const load_wishlist_products = setInterval(function () {
      if (jQuery(".customer_logout .uwl-product-single-wrap").length > 0) {
        $(".customer_logout .uwl-product-single-wrap .wish-atc").remove();
        $(".customer_logout .uwl-product-single-wrap .product-price").remove();
        clearInterval(load_wishlist_products);
      }
    }, 1000);

    if (currentLang == "fr") {
      const load_wishlist_translation = setInterval(function () {
        if (jQuery(".uwl-wishlist-header-title").length > 0) {
          $(".uwl-wishlist-header-title h2").text("Ma liste de souhaits");
          if (jQuery(".uwl-wishlist-header-links .clear-wishlist").length > 0) {
            $(".uwl-wishlist-header-links .clear-wishlist").text(
              "Supprimer la sélection"
            );
          }
          clearInterval(load_wishlist_translation);
        }
      }, 1000);
      const load_wishlist_pro_translation = setInterval(function () {
        if (jQuery(".uwl-product-list .uwl-product-iteam").length > 0) {
          $(
            ".uwl-product-list .uwl-product-iteam .uwl-product-single-wrap .product-view-button a"
          ).text("Voir");
          clearInterval(load_wishlist_pro_translation);
        }
      }, 1000);
    }
  }

  let wishlist_int = setInterval(() => {
    let wishSelector =
      window.location.pathname.indexOf("/apps/wishlist") != -1
        ? ".uwl-remove-wishlist"
        : ".uwl-col-wishlist";
    let $wishIcons = $(wishSelector);
    let customWish = $("#wishlist-icons-svg").html();
    $wishIcons.each(function (i) {
      let $ic = $(this);
      if ($ic.find(".icon-custom").length == 0) {
        $wishIcons.html(customWish);
      }
    });

    // for compare icons
    let $compareIcons = $("#MainContent button.icon.icon-compare");
    let customCompare = $("#compare-icon-svg").html();
    $compareIcons.each(function (i) {
      let $ic = $(this);
      if ($ic.find(".icon-custom").length == 0) {
        $compareIcons.html(customCompare);
      }
    });
  }, 250);
});

function compareAppHandler() {
  let selectors = {
    compare_icon: ".header .header__icon--compare",
    elm_app: "#compare-popup",
    elm_count: ".compare-product-count",
    elm_btn: "#compare-page-btn",
    elm_image: ".compaire-product-img",
  };

  let showCompareIcon = false;
  let compareBtnCount = 0;
  let compareIcon = document.querySelector(selectors.compare_icon);
  if (!compareIcon) return false;
  let compareCount = compareIcon.querySelector(".cart-count-bubble");

  if (document.querySelectorAll(selectors.elm_app).length) {
    compareBtnCount = document.querySelector(selectors.elm_count).textContent;
  } else if (location.href.includes("products-compare")) {
    compareBtnCount = document.querySelectorAll(selectors.elm_image).length;

    // console.log("compareBtnCount", compareBtnCount, currentLang);
    
    let compare_text = currentLang == "fr" ? "Afficher uniquement les différences" : "Nur Unterschiede anzeigen";
    let compare_unit = currentLang == "fr" ? " produits" : " Produkte";

    if (document.querySelector(".total-items")) {
      document.querySelector(".total-items").textContent = compareBtnCount + compare_unit
    }
    if (document.querySelector(".campare-checkbox-text")) {
      document.querySelector(".campare-checkbox-text").textContent = compare_text;
    }
  } else {
    compareBtnCount = 0;
  }

  compareCount.textContent = compareBtnCount;
  showCompareIcon = compareBtnCount == 0;
  // compareIcon.parentElement.classList.toggle("hidden" , showCompareIcon);
  compareIcon.parentElement.classList.toggle(
    "compar-has-no-val",
    showCompareIcon
  );

  toolTipHandler();

  document.body.classList.add('show-icons');

  return compareBtnCount;
}

function toolTipHandler() {
  let compareList = JSON.parse(localStorage.getItem("compareList")) || [];
  let t;

  // Ensure window.compareList is always an array
  if (!Array.isArray(window.compareList)) {
    window.compareList = [];
  }

  if (compareList.length > window.compareList.length) {
    clearTimeout(t);
    const newItem = compareList[compareList.length - 1];

    const tooltip = document.querySelector(".compare-tooltip");
    tooltip.querySelector(".compare-tooltip--img-wrapper img").src =
      newItem.image;
    tooltip.querySelector(".compare-tooltip--title").innerText =
      newItem.productName;
    tooltip.querySelector(".compare-tooltip--link span").innerText =
      document.querySelector(".compare-product-count").textContent;

    tooltip.classList.toggle("open", 1);
    t = setTimeout(() => {
      tooltip.classList.toggle("open", 0);
    }, 5000);
  }

  window.compareList = compareList;
}

function productPageCompare() {
  let changeEvent = new Event("change", {
    bubbles: true,
    cancelable: true,
  });
  let clickEvent = new Event("click", {
    bubbles: true,
    cancelable: true,
  });

  // elements
  let productInfoElm = document.querySelector("product-info");
  let compareIconBtn = productInfoElm.querySelector(".icon-comparision");
  let compareCheckbox = productInfoElm.querySelector(
    ".aico-product-compare input"
  );
  let checkboxLabel = productInfoElm.querySelector("#aico_compare");

  // toggle class on page load
  compareIconBtn.classList.toggle("is--active", compareCheckbox.checked);

  // button click event
  compareIconBtn.addEventListener("click", () => {
    compareCheckbox.checked = !compareCheckbox.checked;

    compareCheckbox.dispatchEvent(changeEvent);
    checkboxLabel.dispatchEvent(clickEvent); // this is working, checkbox change is not working

    // toggle class after change
    compareIconBtn.classList.toggle("is--active", compareCheckbox.checked);
  });
}

window.addEventListener("DOMContentLoaded", () => {
  window.compareList = JSON.parse(localStorage.getItem("compareList")) || [];

  if (document.querySelector("#product-grid .preloading")?.length) {
    let listPage = setInterval(() => {
      let compareBtns = document.querySelectorAll("button.icon-compare");
      if (compareBtns.length) {
        compareBtns.forEach((btn) => {
          let find =
            window.compareList.find(
              (item) => item.productHandle === btn.dataset.producthandle
            ) || "";
          btn.classList.toggle("icon-compare-active", find !== "");
        });
        clearInterval(listPage);
      }
    }, 500);
  }

  document.querySelectorAll("button.icon-compare").forEach((btn) => {
    if (!btn.closest("#product-grid")) {
      var inList = window.compareList.some(
        (item) => item.productHandle === btn.dataset.producthandle
      );
      btn.classList.toggle("icon-compare-active", inList);
    }
  });

  let globalFinder = setInterval(() => {
    let showCompareBtn = compareAppHandler();
    if (showCompareBtn) {
      clearInterval(globalFinder);
    }
  }, 500);

  let wishlistPage = setTimeout(() => {
    document.querySelectorAll("del").forEach((d) => {
      if (d.innerText.trim() != 0.0) {
        d.classList.add("shown");
      }
    });
  }, 1500);

  document.addEventListener(
    "click",
    debounce((event) => {
      compareAppHandler();
    }, 1000)
  );

  // Toggle compare active state for buttons outside #product-grid
  // (AICO's tag_config.js only handles buttons inside #product-grid)
  document.addEventListener("click", (event) => {
    var btn = event.target.closest("button.icon-compare");
    if (btn && !btn.closest("#product-grid")) {
      var handle = btn.dataset.producthandle;
      setTimeout(function () {
        var list = JSON.parse(localStorage.getItem("compareList")) || [];
        var inList = list.some(function (item) {
          return item.productHandle === handle;
        });
        btn.classList.toggle("icon-compare-active", inList);
      }, 300);
    }
  });
});

async function fetchNumberOfDeliveryDays(brand) {
  try {
    const endpoint = `${API_URL}brands?filter[shouldExcludeProducts]=1&filter[isLightVersion]=0&filter[name]=${brand}`;
    const headers = {
      Authorization: Authorization,
      Accept: "application/vnd.api+json",
    };
    const response = await fetch(endpoint, {
      method: "GET",
      headers,
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response}`);
    }
    const data = await response.json();
    return data.data[0].attributes;
  } catch (error) {
    console.error("Error in fetchNumberOfDeliveryDays:", error);
    return null;
  }
}

window.addEventListener("DOMContentLoaded", () => {
  if (location.pathname.endsWith("/pages/products-compare")) {
    const pageActionsTO = setInterval(() => {
      let sharebtnWrapper = document.querySelector(".share-buttons");
      let nothingItem = document.querySelector(".nothing-to-compare");
      // console.log(sharebtnWrapper, nothingItem);
      if (sharebtnWrapper) {
        clearInterval(pageActionsTO);
        sharebtnWrapper.querySelector(
          "button"
        ).innerHTML = `<i class="fa fa-print"></i>`;
        sharebtnWrapper.insertAdjacentHTML(
          "afterbegin",
          `<button type="button" class="share-mail"><i class="fa fa-envelope"></i></button>`
        );
        sharebtnWrapper.insertAdjacentHTML(
          "afterbegin",
          `<span class="clear-compare text-underline">Auswahl löschen</span>`
        );
      }
      if (nothingItem !== null) {
        clearInterval(pageActionsTO);
      }
    }, 100);
  }
});

$(document).ready(function () {
  $(document).on("click", ".share-mail", function () {
    const subject = "ecofort.ch - Vergleichen";
    const srarch_ob = encodeArray(localStorage.getItem("compareList"));
    const pageLink = location.href + "?_ob=" + srarch_ob;
    // console.log("pageLink", pageLink);
    const body = `Vergleichsliste prüfen:\n\n${pageLink}`;
    const mailtoLink = `mailto:?subject=${encodeURIComponent(
      subject
    )}&body=${encodeURIComponent(body)}`;
    window.location.href = mailtoLink;
  });

  $(document).on("click", ".clear-compare", function () {
    let items = localStorage.getItem("compareList");
    items = JSON.parse(items);
    items.forEach((item) => {
      // console.log("item.productId", item.productId);
      remove_product_from_compare_list(item.productId);
      $(".product-" + item.productId).remove();
    });
    location.reload();

    if ($(".remove-compare-product").length > 1) {
      $(".remove-compare-product").show();
    } else {
      $(".remove-compare-product").hide();
    }
  });

  // $(document).on("click", ".clear-wishlist", function () {
  //   let wl_interval = setInterval(() => {
  //     if ($(".uwl-remove-wishlist.uwl-select-icon").length) {
  //       $(".uwl-remove-wishlist.uwl-select-icon:last").click();
  //       $(".uwl-remove-wishlist.uwl-select-icon:last")
  //         .closest(".uwl-product-iteam")
  //         .remove();
  //     } else {
  //       clearInterval(wl_interval);
  //     }
  //   }, 100);
  // });

  // collection page -> Übersicht tab -> sub-category tabs
  $(".collection-ubersicht .tab-head .list-menu__item").on(
    "click",
    function (e) {
      e.preventDefault();
      let target = $(this).data("target");

      $(".collection-ubersicht .tab-head .list-menu__item").removeClass(
        "active"
      );
      $(this).addClass("active");

      $(`.collection-ubersicht .tab-pane`).removeClass("active");
      $(`.collection-ubersicht .tab-pane[data-id='${target}']`).addClass(
        "active"
      );
    }
  );
});

$(document).ready(function () {
  // Select the read-more button and the parent div
  const readMoreBtn = $(".read-more-collection-hero-btn");
  const descriptionWrap = $(".collection-hero .collection-hero__inner");

  // Delay execution by 1 second (1000 milliseconds)
  setTimeout(() => {
    // Add an event listener to the read-more button
    readMoreBtn.on("click", () => {
      // Toggle the 'read-more-text' class on the parent div
      descriptionWrap.toggleClass("read-more-text");
    });
  }, 100); // 1000 milliseconds = 1 second
});

$(document).ready(function () {
  const $rows = $(
    ".product_submenu .tab-content .content-row div .content-html-text .row"
  );

  if ($rows.length > 0) {
    // Only wrap and initialize Slick if more than 1 item
    $rows.wrapAll('<div class="slickSlider"></div>');

    // $(".product_submenu .tab-content .content-row div .content-html-text .slickSlider").slick({
    //   infinite: true,
    //   slidesToShow: 1,
    //   slidesToScroll: 1,
    //   autoplay: false,
    //   autoplaySpeed: 5000,
    //   dots: true,
    //   arrows: true,
    // });
  }
  if ($rows.length > 10) {
    // Hide rows after the 10th
    $rows.slice(10).hide();

    // Add class to the parent based on visible count (10)
    const className = `item_col__wrap col__wrap_10`;
    $rows.parent().addClass(className);
  } else {
    // If 10 or fewer, use actual count
    const className = `item_col__wrap col__wrap_${$rows.length}`;
    $rows.parent().addClass(className);
  }
});

$(document).on("change", "#cart_agree", function () {
  $(".cart__checkout-button").attr(
    "type",
    $(this).is(":checked") ? "submit" : "button"
  );
  $(".cart__tos .error").toggleClass("hidden", $(this).is(":checked"));
});
$(document).on("click", '.cart__checkout-button[type="button"]', function () {
  if (!$(this).is(":checked")) {
    $(".cart__tos .error").removeClass("hidden");
  }
});

$(document).ready(function () {
  $(
    '.template-name--uber-uns .footer-block__details-content a[href^="/pages/ueber-uns#"]'
  ).on("click", function (e) {
    e.preventDefault();
    var target = this.hash;
    var $target = $(target);
    $("html, body")
      .stop()
      .animate(
        {
          scrollTop: $target.offset().top - 63,
        },
        900,
        "swing",
        function () {
          // window.location.hash = target;
        }
      );
  });
});

function selectCustomSortOption(value) {
    const option = document.querySelector(`.af-sort-custom-option[data-value="${value}"]`);
    if (option) {
      option.click(); // simulate user clicking the custom option
    } else {
      console.warn('Custom sort option not found for value:', value);
    }
  }
  
  $(document).on('click', '.af-btn-sort', function (event) {
      event.preventDefault();
       $('.af-btn-sort').removeClass('af-sort-btn-active');
       $(this).addClass('af-sort-btn-active');
      let sortValue = $(this).attr('sort-data');
      if (!sortValue) return false;
      // Update the request data and fetch sorted data
      request_data['sort'] = sortValue;
      delete request_data.page;
      selectCustomSortOption(sortValue)
  });


document.addEventListener('DOMContentLoaded', () => {
    const searchInput = document.querySelector('.aico_custom_search');
    const cartButton = document.querySelector('#cart-icon-bubble');
    const cartDrawer = document.querySelector('#CartDrawer');

    if (!searchInput) {
        return;
    }

    // Prevent cart click from interfering with input
    searchInput.addEventListener('click', (e) => {
        e.stopPropagation(); // Stop event from bubbling to cart
        searchInput.focus(); // Ensure input gets focus
    });

    // Handle cart click separately
    cartButton?.addEventListener('click', (e) => {
        e.stopPropagation();
        // Logic to open cart (if not handled by existing code)
        if (cartDrawer) {
            cartDrawer.style.visibility = 'visible'; // Example toggle
        }
    });

    // Ensure input works after cart is opened
    cartDrawer?.addEventListener('shown', () => { // Replace with actual event if different
        setTimeout(() => searchInput.focus(), 100); // Refocus input after cart animation
    });

    // Handle input events to confirm typing
    searchInput.addEventListener('input', (e) => {
        console.log('Input value:', e.target.value); // Debug typing
    });
});